import store, { useAppSelector } from "../../../global/utils/redux/store.tsx";
import {
  useGetLoggedinUserQuery,
  useLazyContactByIdentifierQuery,
} from "../../../global/utils/redux/api/piggyAuthApi.ts";
import { useEffect } from "react";
// @ts-ignore
import scrollIntoView from "scroll-into-view";
import { piggyUserLogInFailed } from "../../../global/utils/redux/piggySlice.tsx";
import { BlockUserInput } from "@jamezz/react-components";
import { useFetchPrepaidBalanceQuery } from "../../../global/utils/redux/api/piggyApi.ts";

export default function usePiggyLogin() {
  const timestamp = useAppSelector((state) => state.piggy.contactIdentifierScan?.timestamp);
  const [trigger, { isError, isFetching }] = useLazyContactByIdentifierQuery();

  BlockUserInput.useBlockUserInput(isFetching);

  useEffect(() => {
    if (timestamp) {
      const contactIdentifierScan = store.getState().piggy.contactIdentifierScan;
      if (contactIdentifierScan) {
        trigger({
          identifier: contactIdentifierScan.code,
          timestamp: contactIdentifierScan.timestamp,
          create_if_not_exists: true,
        })
          .catch(() => {
            store.dispatch(piggyUserLogInFailed({ code: contactIdentifierScan.code }));
          })
          .then(() => {
            const element = document.getElementById("PiggyLoyaltyContent-Card");
            if (element) {
              scrollIntoView(element, {
                time: 500,
                align: {
                  top: 20,
                },
                validTarget: () => {
                  return true;
                },
              });
            }
          });
      }
    }
  }, [timestamp, trigger]);

  useEffect(() => {
    if (timestamp && isError) {
      const contactIdentifierScan = store.getState().piggy.contactIdentifierScan;
      if (contactIdentifierScan?.timestamp == timestamp) {
        store.dispatch(piggyUserLogInFailed({ code: contactIdentifierScan.code }));
      }
    }
  }, [isError, timestamp]);

  usePreloadPrepaidData();
}

// This is to ensure, there is no loading time when the view of prepaid transactions is shown.
export function usePreloadPrepaidData() {
  const loggedIn = useAppSelector((state) => state.piggy.contactIdentifierLoggedIn);
  const prepaidEnabled = useAppSelector((state) => state.global.salesarea?.piggy?.prepaid?.enabled);
  const { data: loggedInSessionResponse } = useGetLoggedinUserQuery(undefined, {
    skip: !prepaidEnabled || !loggedIn,
  });

  const { data } = useFetchPrepaidBalanceQuery(loggedInSessionResponse?.data?.piggy_contact_uuid ?? "", {
    skip: !prepaidEnabled || !loggedIn || loggedInSessionResponse?.data?.piggy_contact_uuid == null,
  });

  return data?.data;
}
